import { WritableSignal } from '@angular/core';
import { form, maxLength, required, validate } from '@angular/forms/signals';

import { ProblemDescription } from '@core/models/problem-description.model';

const ACCEPTED_MIME_TYPES = ['image/png', 'image/jpeg', 'application/pdf'];
const MAX_FILE_SIZE_BYTES = 500 * 1024; // 500 Ko

export function createDescriptionForm(
  model: WritableSignal<ProblemDescription>,
  descriptionMaxLength: number,
) {
  return form(model, (path) => {
    required(path.theme);
    required(path.description);
    maxLength(path.description, descriptionMaxLength);

    //required(path.attachments, { message: 'common.errors.required' });

    validate(path.attachments, ({ value }) => {
      const hasInvalidFormat = value().some((file) => !ACCEPTED_MIME_TYPES.includes(file.type));
      return hasInvalidFormat
        ? {
            kind: 'invalidFormat',
            message: 'screens.description.panel.content.form.attachment.errors.format',
          }
        : null;
    });

    validate(path.attachments, ({ value }) => {
      const hasFileTooLarge = value().some((file) => file.size > MAX_FILE_SIZE_BYTES);
      return hasFileTooLarge
        ? {
            kind: 'fileTooLarge',
            message: 'screens.description.panel.content.form.attachment.errors.size',
          }
        : null;
    });
  });
}
